"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../utils");
var _Button = _interopRequireDefault(require("./../Business/Button"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/*
 * @Author: syd
 * @Date: 2021-02-04 04:24:59
 * @Last Modified by: syd
 * @Last Modified time: 2021-04-07 17:46:13
 */
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var Contact = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var title = props.title,
    content = props.content,
    extendProps = props.extendProps,
    style = props.style,
    hrefText = props.hrefText,
    href = props.href,
    pcBackgroundImage = props.pcBackgroundImage,
    mbBackgroundImage = props.mbBackgroundImage,
    buttonConfig = props.buttonConfig;
  var _a = (0, _react.useState)(''),
    pcBgUrl = _a[0],
    setPcBgUrl = _a[1];
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function (status) {
      if (status) {
        var url = (0, _utils.fomateFileData)(pcBackgroundImage).url;
        setPcBgUrl(url);
      } else {
        var url = (0, _utils.fomateFileData)(mbBackgroundImage).url;
        setPcBgUrl(url);
      }
    }, 1);
  }, [pcBgUrl]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: 'flex-contact-default',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: 'flex-contact-default-container',
    style: pcBgUrl ? {
      background: "url(" + pcBgUrl + ")  no-repeat center center",
      backgroundSize: '100% 100%'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-contact-default-container-include'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-contact-default-container-left'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-contact-default-title'
  }, title), /*#__PURE__*/_react["default"].createElement("p", null, content)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-contact-default-container-right', {
      'flex-contact-default-container-right--expand': (0, _typeof2["default"])(buttonConfig) === 'object',
      'flex-contact-default-container-right--array': !Array.isArray(buttonConfig)
    })
  }, hrefText ? ( /*#__PURE__*/_react["default"].createElement("a", __assign({
    className: 'flex-contact-default-container-right__a'
  }, extendProps || {}, {
    href: href
  }), hrefText)) : ( /*#__PURE__*/_react["default"].createElement(RenderBut, __assign({
    extendProps: extendProps,
    buttonConfig: buttonConfig
  }, buttonConfig || {})))))));
});
Contact.displayName = 'TCIContact';
var _default = exports["default"] = Contact;
function RenderBut(props) {
  var _extendProps = props.extendProps,
    buttonConfig = props.buttonConfig;
  var type = buttonConfig ? Object.prototype.toString.call(buttonConfig) : null;
  switch (type) {
    case '[object Array]':
      return buttonConfig.map(function (item, index) {
        var extendProps = (item || {}).extendProps;
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], __assign({
          key: index,
          extendProps: extendProps
        }, item || {}));
      });
    case '[object Object]':
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], __assign({
        extendProps: _extendProps
      }, buttonConfig || {}));
    default:
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], __assign({
        extendProps: _extendProps
      }, buttonConfig || {}));
  }
}